import classnames from 'classnames';
import { Utils } from 'common';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { DataDisplayPanel } from './DataDisplayPanel.component';

const { Util } = Utils;

const CustomsDetailsPanel = ({ customs }) => {
	const { contentsType, customsItems, nonDeliveryOption, senderInfo } = customs;
	const { internalTransactionNumber } = senderInfo || {};
	let totalValue = 0;

	return (
		<>
			<div className="customs-details">
				<DataDisplayPanel
					label="Package Content:"
					body={contentsType}
					dataqa="package-content"
				/>
				<DataDisplayPanel
					label="Non-Delivery:"
					body={nonDeliveryOption}
					dataqa="non-delivery"
				/>
				{!isEmpty(customs) && (
					<DataDisplayPanel
						label="ITN:"
						body={internalTransactionNumber || 'Not required'}
						dataqa="itn-number"
					/>
				)}
				<hr />
			</div>

			<div className="customs-details">
				<div className="p-col-12 content">
					<div className="label p-col-3">Qty.</div>
					<div className="label p-col-7">Item Description</div>
					<div className="label p-col-2">Price</div>
				</div>

				{customsItems.map((customItem, index) => {
					const { itemDescription, quantity, unitValue } = customItem;
					const { amount } = unitValue;
					totalValue += (quantity || 0) * (amount || 0);

					return (
						<div
							className="p-col-12 content"
							data-qa={`customs-item-${index}`}
							{...{ dataqa: `customs-item-${index}` }}
							key={index}
						>
							<div
								className="p-col-3"
								data-qa={`quantity-${index}`}
								{...{ dataqa: `quantity-${index}` }}
							>
								{quantity}
							</div>

							<div
								className={classnames('p-col-7', amount ? 'add-dot-space' : '')}
								data-qa={`item-description-${index}`}
								{...{ dataqa: `item-description-${index}` }}
							>
								{itemDescription}
							</div>

							<div
								className="p-col-2  customs-amount"
								data-qa={`price-${index}`}
								{...{ dataqa: `price-${index}` }}
							>
								{Util.formatCurrency(amount)}
							</div>
						</div>
					);
				})}
				<hr />
				<div className="p-col-12 content">
					<div className="p-col-3" />
					<div
						className="label p-col-7"
						data-qa="customs-total-label"
						{...{ dataqa: 'customs-total-label' }}
					>
						Total Value:
					</div>
					<div
						className="p-col-2"
						data-qa="customs-total-price"
						{...{ dataqa: 'customs-total-price' }}
					>
						{Util.formatCurrency(totalValue)}
					</div>
				</div>
			</div>
		</>
	);
};

export default CustomsDetailsPanel;
